import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App";
import CatalogList from "./component/page/CatalogList.js";
import CatalogPriceUpdate from "./component/page/CatalogPriceUpdate.js";
import SalesOrders from "./component/page/SalesOrders.js";
import Login from "./component/common/Login.js";
import ForgotPassword from "./component/common/ForgotPassword.js";
import SalesOrderView from "./component/page/SalesOrderView.js";
import AddNewCatalog from "./component/page/AddNewCatalog.js";
import PurchaseOrders from "./component/page/PurchaseOrders.js";
import Employee from "./component/page/Employee.js";
import ResetPassword from "./component/common/ResetPassword.js";
import { SessionProvider } from "./component/contextApi/SessionContext.js";
import Dashboard from "./component/page/Dashboard.js";
import MyAccount from "./component/common/MyAccount.js";
import { RoleProvider } from "./component/contextApi/RoleContext.js";
import ProtectedRoute from "./ProtectedRoute.js";
import AccessDenied from "./component/page/AccessDenied.js";
import RolePermissions from "./component/page/RolePermissions.js";
import Roles from "./component/page/Roles.js";
import AddRoles from "./component/page/AddRoles.js";
import EditRole from "./component/page/EditRole.js";
import NotFoundPage from "./component/page/NotFoundPage.js";
import Users from "./component/page/Users.js";
import AddUsers from "./component/page/AddUsers.js";
import EditUser from "./component/page/EditUser.js";
import GeneratePassword from "./component/common/GeneratePassword.js";
import { useEffect } from "react";
import UpcChecker from "./component/page/UpcChecker.js";
import SalesReport from "./component/page/SalesReport.js";
import SalesReportFilter from "./component/page/SalesReportFilter.js";
import TicketsHistory from "./component/page/TicketsHistory.js";
import Poc from "./component/page/Poc.js";
import AddStores from "./component/page/AddStores.js";
import AddtStoreData from "./component/page/AddtStoreData.js";
import ListStores from "./component/page/ListStores.js";
import ListtStoreData from "./component/page/ListtStoreData.js";
import EditStores from "./component/page/EditStores.js";
import EdittStoreData from "./component/page/EdittStoreData.js";
import ShopifyProducts from "./component/page/ShopifyProducts.js";
import ShopifyExtract from "./component/page/ShopifyExtract.js";
import ShopifyDataImport from './component/page/ShopifyDataImport';
import ThemeUpload from './component/page/ThemeUpload';





function Root() {
  return (
    <Routes>
      {/* This Route renders the App layout */}
      <Route path="/" element={<App />}>
        {/* The nested routes render inside the App layout using Outlet */}
        <Route
          path="/"
          element={
            <ProtectedRoute pageId="1">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee"
          element={
            <ProtectedRoute pageId="2">
              <Employee />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalog-list"
          element={
            <ProtectedRoute pageId="3">
              <CatalogList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/web-orders"
          element={
            <ProtectedRoute pageId="4">
              <SalesOrders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-report"
          element={
            <ProtectedRoute pageId="10">
              <SalesReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-report-filter"
          element={
            <ProtectedRoute pageId="10">
              <SalesReportFilter />
            </ProtectedRoute>
          }
        />
        <Route
          path="/purchase-orders"
          element={
            <ProtectedRoute pageId="5">
              <PurchaseOrders />
            </ProtectedRoute>
          }
        />

        <Route
          path="/roles"
          element={
            <ProtectedRoute pageId="8">
              <Roles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute pageId="9">
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/myaccount"
          element={
            <ProtectedRoute type="common">
              <MyAccount />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-new-catalog"
          element={
            <ProtectedRoute type="add" pageId="3">
              <AddNewCatalog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/catalog-price-update"
          element={
            <ProtectedRoute type="edit" pageId="3">
              <CatalogPriceUpdate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/web-orders-view"
          element={
            <ProtectedRoute type="common">
              <SalesOrderView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee"
          element={
            <ProtectedRoute type="common">
              <Employee />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addroles"
          element={
            <ProtectedRoute type="add" pageId="8">
              <AddRoles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upcchecker"
          element={
            <ProtectedRoute type="add" pageId="3">
              <UpcChecker />
            </ProtectedRoute>
          }
        />
        <Route
          path="/editrole/"
          element={
            <ProtectedRoute type="edit" pageId="8">
              <EditRole />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adduser"
          element={
            <ProtectedRoute type="add" pageId="9">
              <AddUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edituser/"
          element={
            <ProtectedRoute type="edit" pageId="9">
              <EditUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/shopifydataimport"
          element={
            <ProtectedRoute type="common">
              <ShopifyDataImport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/themeupload"
          element={
            <ProtectedRoute type="common">
              <ThemeUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addtstoredata"
          element={
            <ProtectedRoute type="common">
              <AddtStoreData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addstores"
          element={
            <ProtectedRoute type="common">
              <AddStores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/liststores"
          element={
            <ProtectedRoute type="common">
              <ListStores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/listtstoredata"
          element={
            <ProtectedRoute type="common">
              <ListtStoreData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/editstores"
          element={
            <ProtectedRoute type="common">
              <EditStores />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edittstoredata"
          element={
            <ProtectedRoute type="common">
              <EdittStoreData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tickets-history"
          element={
            <ProtectedRoute pageId="1">
              <TicketsHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accessdenied"
          element={
            <ProtectedRoute type="common">
              <AccessDenied />
            </ProtectedRoute>
          }
        />
        <Route
          path="/poc"
          element={
            <Poc/>
          }
        />
        <Route
          path="/shopify-products"
          element={

            <ProtectedRoute pageId="1">
            <ShopifyProducts/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/shopify-extract"
          element={

            <ProtectedRoute type="common">
            <ShopifyExtract/>
            </ProtectedRoute>
          }
        />
       
        
        {/* <Route path="/add-new-catalog" element={<AddNewCatalog />} /> */}
        {/* <Route path="/catalog-price-update" element={<CatalogPriceUpdate />} /> */}
        {/* <Route path="/web-orders-view" element={<SalesOrderView />} /> */}
        {/* <Route path="/setting" element={<RolePermissions />} /> */}
        {/* <Route path="/employee" element={<Employee />} /> */}
        {/* <Route path="/roles" element={<Roles />} /> */}
        {/* <Route path="/addroles" element={<AddRoles />} /> */}
        {/* <Route path="/editrole/:id" element={<EditRole />} /> */}
        {/* <Route path="/users" element={<Users />} /> */}
        {/* <Route path="/adduser" element={<AddUsers />} /> */}
        {/* <Route path="/edituser/:id" element={<EditUser />} /> */}

        {/* <Route path="/employee" element={<Employee />} /> */}
        {/* <Route path="/myaccount" element={<MyAccount />} /> */}
        {/* <Route path="/accessdenied" element={<AccessDenied />} /> */}
      </Route>
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/resetpassword/:token" element={<ResetPassword />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<NotFoundPage />} />
      <Route
        path="/generatepassword"
        element={
          // <ProtectedRoute type="common">
          <GeneratePassword />
          // </ProtectedRoute>
        }
      />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
// Wrap everything in BrowserRouter, including Root component
root.render(
  <BrowserRouter>
    <RoleProvider>
      <Root />
    </RoleProvider>
  </BrowserRouter>
);
